var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8064 7.62288L20.184 6.54279C19.6574 5.62887 18.4905 5.31359 17.5753 5.83798V5.83798C17.1397 6.09461 16.6198 6.16742 16.1305 6.04035C15.6411 5.91329 15.2224 5.59678 14.9666 5.16064C14.8021 4.88342 14.7137 4.56766 14.7103 4.24531V4.24531C14.7251 3.72849 14.5302 3.22767 14.1698 2.85694C13.8094 2.4862 13.3143 2.27713 12.7973 2.27734H11.5433C11.0367 2.27734 10.5511 2.47918 10.1938 2.83821C9.83644 3.19724 9.63693 3.68386 9.63937 4.19039V4.19039C9.62435 5.23619 8.77224 6.07608 7.72632 6.07597C7.40397 6.07262 7.08821 5.98421 6.81099 5.81968V5.81968C5.89582 5.29528 4.72887 5.61056 4.20229 6.52448L3.5341 7.62288C3.00817 8.53566 3.31916 9.70187 4.22975 10.2316V10.2316C4.82166 10.5733 5.18629 11.2049 5.18629 11.8883C5.18629 12.5718 4.82166 13.2033 4.22975 13.5451V13.5451C3.32031 14.0712 3.00898 15.2346 3.5341 16.1446V16.1446L4.16568 17.2339C4.4124 17.679 4.82636 18.0076 5.31595 18.1467C5.80554 18.2859 6.3304 18.2242 6.77438 17.9753V17.9753C7.21084 17.7206 7.73094 17.6508 8.2191 17.7815C8.70725 17.9121 9.12299 18.2323 9.37392 18.6709C9.53845 18.9482 9.62686 19.2639 9.63021 19.5863V19.5863C9.63021 20.6428 10.4867 21.4993 11.5433 21.4993H12.7973C13.8502 21.4993 14.7053 20.6484 14.7103 19.5954V19.5954C14.7079 19.0873 14.9086 18.5993 15.2679 18.24C15.6272 17.8807 16.1152 17.6799 16.6233 17.6824C16.9449 17.691 17.2594 17.779 17.5387 17.9387V17.9387C18.4515 18.4646 19.6177 18.1536 20.1474 17.243V17.243L20.8064 16.1446C21.0615 15.7068 21.1315 15.1853 21.001 14.6956C20.8704 14.206 20.55 13.7886 20.1108 13.5359V13.5359C19.6715 13.2832 19.3511 12.8658 19.2206 12.3762C19.09 11.8866 19.16 11.3651 19.4151 10.9272C19.581 10.6376 19.8211 10.3975 20.1108 10.2316V10.2316C21.0159 9.70216 21.3262 8.54276 20.8064 7.63203V7.63203V7.62288Z",
    stroke: "#777F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1747,
    cy: 11.8881,
    r: 2.63616,
    stroke: "#777F99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.2b30caa73adf79a0da727a2edeb07379.svg";
export { ForwardRef as ReactComponent };